import axios from 'axios';
// ---- external imports ----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports ----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { EMPLOYEE_APIS } from '../endpoints';
// ---- local imports ----

class EmployeesService {
	async hire(gameUserId, slug) {
		const data = { employee: slug };

		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${EMPLOYEE_APIS.HIRE}`
		});

		return formatResponse(response);
	}

	async fire(gameUserId, id) {
		const data = { hiredEmployeeId: id };

		const response = await ApiService.request({
			method: 'POST',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${EMPLOYEE_APIS.FIRE}`
		});

		return formatResponse(response);
	}

	async getAllEmployees() {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/${EMPLOYEE_APIS.GET_ALL}`
		});

		return formatResponse(response);
	}

	async getHiredEmployees(gameUserId) {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${EMPLOYEE_APIS.HIRED_LIST}`
		});

		return formatResponse(response);
	}
}

export default new EmployeesService();
